// This is a part of the Cadcorp SIS source code. 
// Copyright (c) Cadcorp Limited 1991-2025 
import { Events as events } from './Core/Cadcorp.Web.Core.Events';
import { Geolocator as geolocator, OlCoordPositionTransformer as olCoordPositionTransformer } from './Core/Cadcorp.Web.Core.Geolocator';
import { AjaxWrapper as ajaxWrapper } from './Core/AjaxWrapper';
import {TemplateFactory as templateFactory} from './Core/TemplateFactory';
import { GeoLocatorErrorEnum as geoLocatorErrorEnum } from '../../../CommonScripts/Abstractions';
import { CookieManager as cookieManager } from './Core/CookieManager';
import { SearchFactory as searchFactory } from './Search/SearchFactory';
import { LayerFactory as layerFactory } from './ol/LayerFactory';
var Cadcorp = window['Cadcorp'];
if (!Cadcorp) {
    Cadcorp = {};
    window['Cadcorp'] = Cadcorp;
}
if (!Cadcorp.Core)
    Cadcorp.Core = {};
Cadcorp.Core.Events = events;
Cadcorp.Core.GeoLocator = geolocator;
Cadcorp.Core.GeoLocatorErrorEnum = geoLocatorErrorEnum;
Cadcorp.Core.OlCoordPositionTransformer = olCoordPositionTransformer;
Cadcorp.Core.AjaxWrapper = ajaxWrapper;
Cadcorp.Core.CookieManager = cookieManager;
Cadcorp.Core.TemplateFactory = templateFactory;
Cadcorp.Core.SearchFactory = searchFactory;
Cadcorp.Core.LayerFactory = layerFactory;

export module Core {
    export const Events = events;
    export const Geolocator = geolocator;
    export const GeoLocatorErrorEnum = geoLocatorErrorEnum;
    export const OlCoordPositionTransformer = olCoordPositionTransformer;
    export const AjaxWrapper = ajaxWrapper;
    export const CookieManager = cookieManager;
    export const TemplateFactory = templateFactory;
    export const SearchFactory = searchFactory;
    export const LayerFactory = layerFactory;
}

import { SchemaColumn as schemaColumn } from './GeognoSIS/SchemaColumn';
import { Item as item, CursorItem as cursorItem } from './GeognoSIS/Item';
import { IntersectExpressionBuilder as intersectExpressionBuilder } from './GeognoSIS/ExpressionBuilder';
import { GeognosisFilterExpressionBuilder as geognosisFilterExpressionBuilder } from './GeognoSIS/GeognosisFilter';
import { QueryHelper as queryHelper } from './GeognoSIS/QueryHelper';
import { JoinedOverlayQueryHelper as joinedOverlayQueryHelper } from './GeognoSIS/JoinedQueryHelper';
import { Overlay as overlay, LayerStatus as layerStatus } from './GeognoSIS/Overlay';
import { OverlayFactory as overlayFactory } from './GeognoSIS/OverlayFactory';
import { Theme as theme, HorizontalTextAlignment as horizontalTextAlignment, VerticalTextAlignment as verticalTextAlignment} from './GeognoSIS/Theme';

if (!Cadcorp.Core.GeognoSIS)
    Cadcorp.Core.GeognoSIS = {};
Cadcorp.Core.GeognoSIS.SchemaColumn = schemaColumn;
Cadcorp.Core.GeognoSIS.Item = item;
Cadcorp.Core.GeognoSIS.CursorItem = cursorItem;
Cadcorp.Core.GeognoSIS.IntersectExpressionBuilder = intersectExpressionBuilder;
Cadcorp.Core.GeognoSIS.GeognosisFilterExpressionBuilder = geognosisFilterExpressionBuilder;
Cadcorp.Core.GeognoSIS.QueryHelper = queryHelper;
Cadcorp.Core.GeognoSIS.JoinedOverlayQueryHelper = joinedOverlayQueryHelper;
Cadcorp.Core.GeognoSIS.Overlay = overlay;
Cadcorp.Core.GeognoSIS.LayerStatusEnum = layerStatus;
Cadcorp.Core.GeognoSIS.OverlayFactory = overlayFactory;
Cadcorp.Core.GeognoSIS.Theme = theme;
Cadcorp.Core.GeognoSIS.HorizontalTextAlignmentEnum = horizontalTextAlignment;
Cadcorp.Core.GeognoSIS.VerticalTextAlignmentEnum = verticalTextAlignment;

export module Core.GeognoSIS {
    export const SchemaColumn = schemaColumn;
    export const Item = item;
    export const CursorItem = cursorItem;
    export const IntersectExpressionBuilder = intersectExpressionBuilder;
    export const QueryHelper = queryHelper;
    export const JoinedOverlayQueryHelper = joinedOverlayQueryHelper;
    export const Overlay = overlay;
    export const LayerStatusEnum = layerStatus;
    export const OverlayFactory = overlayFactory;
    export const Theme = theme;
    export const HorizontalTextAlignmentEnum = horizontalTextAlignment;
    export const VerticalTextAlignmentEnum = verticalTextAlignment;
}

import { extend, hideLoading, removeInvalidJavascriptChars, appendParameters, formatDate, formatValue } from './Core/Utils';
import { isUrl, isNumber, validate, isEmail, notEmpty, notEmptyArray, isPostcode, isUnsignedInteger, isUnsignedDecimal } from './Core/validation';
if (!Cadcorp.Core.Utils)
    Cadcorp.Core.Utils = {};
Cadcorp.Core.Utils.Extend = extend;
Cadcorp.Core.Utils.HideLoading = hideLoading;
Cadcorp.Core.Utils.RemoveInvalidJavascriptChars = removeInvalidJavascriptChars;
Cadcorp.Core.Utils.AppendParameters = appendParameters;
Cadcorp.Core.Utils.FormatDate = formatDate;
Cadcorp.Core.Utils.FormatValue = formatValue;
Cadcorp.Core.Utils.IsUrl = isUrl;
Cadcorp.Core.Utils.IsNumber = isNumber;
Cadcorp.Core.Utils.IsUnsignedDecimal = isUnsignedDecimal;
Cadcorp.Core.Utils.IsUnsignedInteger = isUnsignedInteger;
Cadcorp.Core.Utils.Validate = validate;
Cadcorp.Core.Utils.IsEmail = isEmail;
Cadcorp.Core.Utils.IsPostcode = isPostcode;
Cadcorp.Core.Utils.NotEmpty = notEmpty;
Cadcorp.Core.Utils.NotEmptyArray = notEmptyArray;

export module Core.Utils {
    export const Extend = extend;
    export const HideLoading = hideLoading;
    export const RemoveInvalidJavascriptChars = removeInvalidJavascriptChars;
    export const AppendParameters = appendParameters;
    export const FormatDate = formatDate;
    export const IsUrl = isUrl;
    export const IsNumber = isNumber;
    export const FormatValue = formatValue;
}

import geognosisTileImage from './ol/source/GeognoSISTileImage';
import geognosisVector from './ol/source/GeognoSISVector';
if (!Cadcorp.ol)
    Cadcorp.ol = {};
if (!Cadcorp.ol.source)
    Cadcorp.ol.source = {};
Cadcorp.ol.source.GeognoSISTileImage = geognosisTileImage;
Cadcorp.ol.source.GeognoSISVector = geognosisVector;
export module ol.source {
    export const GeognoSISTileImage = geognosisTileImage;
    export const GeognoSISVector = geognosisVector;
}
import applicationPanel from './Components/MapView/Panels/applicationPanel.vue';
import sidePanel from './Components/MapView/Panels/sidepanel.vue';
import attributionPanel from './Components/MapView/Panels/attributionPanel.vue';
import activitySnackBar from './Components/MapView/Notifications/activitySnackbar.vue';
import errorSnackBar from './Components/MapView/Notifications/errorSnackbar.vue';
import cookieSnackBar from './Components/MapView/Notifications/cookieSnackbar.vue';
import notificationSnackBar from './Components/MapView/Notifications/notificationSnackbar.vue';
import appControls from './Components/MapView/ContentControls/appControls.vue';
import appControl from './Components/MapView/ContentControls/contentControl.vue';
import menuItem from './Components/MapView/NavigationDrawer/navigationItem.vue';
import navigationDrawer from './Components/MapView/NavigationDrawer/navigationDrawer.vue';
import speedDial from './Components/MapView/speedDial/speedDial.vue';
import speedDialItem from './Components/MapView/speedDial/speedDialItem.vue';
import map from './Components/MapView/Application/map.vue';
import applicationPanelContent from './Components/MapView/Panels/applicationPanelContents.vue';
import button from './Components/MapView/Application/button.vue';
import { ThemeEnum as themeEnum, ButtonSizeEnum as buttonSizeEnum } from '../../../CommonScripts/Abstractions';

if (!Cadcorp.Core.Components)
    Cadcorp.Core.Components = {};
Cadcorp.Core.Components.ApplicationPanel = applicationPanel;
Cadcorp.Core.Components.ApplicationPanelContents = applicationPanelContent;
Cadcorp.Core.Components.SidePanel = sidePanel;
Cadcorp.Core.Components.MapView = map;
Cadcorp.Core.Components.ActivitySnackBar = activitySnackBar;
Cadcorp.Core.Components.ErrorSnackBar = errorSnackBar;
Cadcorp.Core.Components.CookieSnackBar = cookieSnackBar;
Cadcorp.Core.Components.NotificationSnackBar = notificationSnackBar;
Cadcorp.Core.Components.ThemeEnum = themeEnum;
Cadcorp.Core.Components.ButtonSizeEnum = buttonSizeEnum;
Cadcorp.Core.Components.TooltipButton = button;
Cadcorp.Core.Components.AttributionPanel = attributionPanel;
export module Core.Components {
    export const ApplicationPanel = applicationPanel;
    export const ApplicationPanelContents = applicationPanelContent;
    export const SidePanel = sidePanel;
    export const ActivitySnackBar = activitySnackBar;
    export const ErrorSnackBar = errorSnackBar;
    export const CookieSnackBar = cookieSnackBar;
    export const NotificationSnackBar = notificationSnackBar;
    export const MapView = map;
    export const ThemeEnum = themeEnum;
    export const ButtonSizeEnum = buttonSizeEnum;
    export const TooltipButton = button;
    export const AttributionPanel = attributionPanel;
}
if (!Cadcorp.Core.Components.Navigation)
    Cadcorp.Core.Components.Navigation = {};
Cadcorp.Core.Components.Navigation.NavigationDrawer = navigationDrawer;
Cadcorp.Core.Components.Navigation.NavigationItem = menuItem;
export module Core.Components.Navigation {
    export const NavigationDrawer = navigationDrawer;
    export const NavigationItem = menuItem;
}
if (!Cadcorp.Core.Components.ContentControls)
    Cadcorp.Core.Components.ContentControls = {};
Cadcorp.Core.Components.ContentControls.AppControls = appControls;
Cadcorp.Core.Components.ContentControls.AppControl = appControl;
Cadcorp.Core.Components.ContentControls.SpeedDial = speedDial;
Cadcorp.Core.Components.ContentControls.SpeedDialItem = speedDialItem;
export module Core.Components.ContentControls {
    export const AppControls = appControls;
    export const AppControl = appControl;
    export const SpeedDial = speedDial;
    export const SpeedDialItem = speedDialItem;
}

import featureTable from './Components/MapView/DataTable/featureTable.vue';
import { DataTableFactory } from './Components/MapView/DataTable/dataTableFactory';

if (!Cadcorp.Core.Components.FeatureTable)
    Cadcorp.Core.Components.FeatureTable = {};
Cadcorp.Core.Components.FeatureTable.table = featureTable;
Cadcorp.Core.Components.FeatureTable.dataTableFactory = DataTableFactory;

import store from './Store/application';
if (!Cadcorp.Core.Store)
    Cadcorp.Core.Store = {};
Cadcorp.Core.Store.ApplicationStore = store;
export module Core.Store {
    export const ApplicationStore = store;
}
import { createLocalStorage } from './Store/localStorage';
import { openDB, deleteDB, wrap } from 'idb';
if (!Cadcorp.Core.LocalStorage)
    Cadcorp.Core.LocalStorage = {};
Cadcorp.Core.LocalStorage.CreateLocalStorage = createLocalStorage;
Cadcorp.Core.LocalStorage.OpenDB = openDB;
Cadcorp.Core.LocalStorage.DeleteDB = deleteDB;
Cadcorp.Core.LocalStorage.WrapDb = wrap;
export module Core.LocalStorage {
    export const CreateLocalStorage = createLocalStorage;
    export const OpenDB = openDB;
    export const DeleteDB = deleteDB;
    export const WrapDb = wrap;
}
import { renderCircle, renderLine, renderPoint, renderPolygon, renderText, renderPointImage } from './Components/ManagerView/Style/previewFunctions';
import colourPicker from './Components/ManagerView/Style/colourPicker.vue';

Cadcorp.Core.Style =
{
    ColourPicker: colourPicker,
    PreviewFunctions: {
        Circle: renderCircle,
        Line: renderLine,
        Point: renderPoint,
        Polygon: renderPolygon,
        Text: renderText,
        PointImage: renderPointImage
    }
}


